import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { getBenef } from '../../../../Store/storages/BeneficiarioStorage';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { Especialidade } from '../../../../interfaces/entities/Especialidade';
import { Anexo } from '../../../../interfaces/entities/Reembolso/Anexo';
import { DadosContaBeneficiario, LstDadosContasCadastradas } from '../../../../interfaces/entities/Reembolso/DadosContaBeneficiario';
import { DadosPrestador } from '../../../../interfaces/entities/Reembolso/DadosPrestador';
import { ProcedimentoRealizado } from '../../../../interfaces/entities/Reembolso/ProcedimentoRealizado';
import { ResumoReembolsoExecutivo } from '../../../../interfaces/entities/Reembolso/ResumoReembolsoExecutivo';
import { DefaultRefundRequestTabsEnum } from '../../../../interfaces/enum/DefaultRefundRequestTabsEnum';
import { ExecutiveRefundRequestTabsEnum } from '../../../../interfaces/enum/ExecutiveRefundRequestTabsEnum';
import { Dados } from '../../../../interfaces/props/Financeiro/Reembolso/ReembolsoPadrao';
import { cancelaPedidoReembolso, getDadosContaBeneficiarioProdutoExecutivo, getdadosrevisaoprodutoexecutivo, getLiminarReembolso, getReembolsoPadrao, gravaarquivospedidoreembolso, gravaPedidoReembolso, gravarPedidoOuvidorReembolso, inclurProcedimentos } from '../../../../services/Financeiro/ReembolsoService';
import ProtocolShow from './ProtocolShow';
import ProtocolStep from './ProtocolStep';
import RegrasReembolsoModal from './RegrasReembolsoModal';
import StepAnexoMotivo from './StepAnexoMotivo';
import StepDadosParaCreditoEmConta from './StepDadosParaCreditoEmConta';
import StepDadosPrestador from './StepDadosPrestador';
import StepDadosProcedimento from './StepDadosProcedimento';
import StepDadosProcedimentoExecutivo from './StepDadosProcedimentoExecutivo';
import StepRevisaoFinalizacaoExecutivo from './StepRevisaoFinalizacaoExecutivo';
import StepSelecaoBeneficiario from './StepSelecaoBeneficiario';
import StepTermoFinalizacao from './StepTermoFinalizacao';
import TermoDeUsoModal from './TermoDeUsoModal';
import { defaultAccount, defaultDadosContaBeneficiario, defaultReembolsoPadrao } from './defaultStates';
import './styles.css';
import { ListaDependentes } from '../../../../interfaces/entities/Reembolso/Dependentes';
import DefaultTabs from '../../../../components/Accessibility/DefaultTabs';
import PageTitle from '../../../../components/Accessibility/PageTitle';


function SolicitacaoDeReembolso() {

  const accessibility = useAccessibility();

  const benef = getBenef();
  const [beneficiary, setBeneficiary] = useState<ListaDependentes | null>(null);
  const [tipoReembolso, setTipoReembolso] = useState<'executivo' | 'pleno' | 'padrao'>('padrao');
  const [agreed, setAgreed] = useState<boolean>(false);
  const [step, setStep] = useState<ExecutiveRefundRequestTabsEnum | DefaultRefundRequestTabsEnum>(0);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [reembolso, setReembolso] = useState<Dados>(defaultReembolsoPadrao);
  const [open, setOpen] = useState<boolean>(false);
  const [openRules, setOpenRules] = useState<boolean>(false);
  const [rulesSelecaoBeneficiario, setRulesSelecaoBeneficiario] = useState<boolean>(false);
  const [dadosPrestador, setDadosPrestador] = useState<DadosPrestador>();
  const [userRequestedToEditInfos, setUserRequestedToEditInfos] = useState<boolean>(false);
  const [valorTotal, setValorTotal] = useState<string>('');
  const [lstProcedimentosRealizados, setLstProcedimentosRealizados] = useState<ProcedimentoRealizado[]>([]);
  const [lstEspecialidades, setLstEspecialidades] = useState<Especialidade[]>([]);
  const [protocol, setProtocol] = useState<string>('');
  const [protocolAtendimentoPrevio, setProtocolAtendimentoPrevio] = useState<string>('');
  const [cel, setCel] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [cost, setCost] = useState<string>('');
  const [resumoReembolso, setResumoReembolso] = useState<ResumoReembolsoExecutivo>();
  const [anexos, setAnexos] = useState<Array<Anexo>>([]);
  const [motivoAtendimentoParticular, setMotivoAtendimentoParticular] = useState<string>('');
  const [finalized, setFinalized] = useState<boolean>(false);
  const [idPedidoReembolso, setIdPedidoReembolso] = useState<string>('');
  const [account, setAccount] = useState<LstDadosContasCadastradas>(defaultAccount);
  const [dadosContaBeneficiario, setDadosContaBeneficiario] = useState<DadosContaBeneficiario>(defaultDadosContaBeneficiario);
  const navigate = useNavigate();
  const { progress } = useParams();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  useEffect(() => {
    if (progress !== undefined && tipoReembolso === 'executivo') {
      switch (progress) {
        case '0':
          setStep(ExecutiveRefundRequestTabsEnum.Protocol);
          break;
        case '1':
          setStep(ExecutiveRefundRequestTabsEnum.SelecaoBeneficiario);
          break;
        case '2':
          setStep(ExecutiveRefundRequestTabsEnum.DadosParaCreditoEmConta);
          break;
        case '3':
          setStep(ExecutiveRefundRequestTabsEnum.DadosProcedimento);
          break;
        case '4':
          setStep(ExecutiveRefundRequestTabsEnum.RevisaoFinalizacao);
          break;
        default:
          break;
      }
    }
    else {
      switch (progress) {
        case '0':
          setStep(DefaultRefundRequestTabsEnum.Protocol);
          break;
        case '1':
          setStep(DefaultRefundRequestTabsEnum.SelecaoBeneficiario);
          break;
        case '2':
          setStep(DefaultRefundRequestTabsEnum.DadosParaCreditoEmConta);
          break;
        case '3':
          setStep(DefaultRefundRequestTabsEnum.DadosPrestador);
          break;
        case '4':
          setStep(DefaultRefundRequestTabsEnum.DadosProcedimento);
          break;
        case '5':
          setStep(DefaultRefundRequestTabsEnum.AnexosMotivo);
          break;
        case '6':
          setStep(DefaultRefundRequestTabsEnum.TermosFinalizacao);
          break;
        default:
          break;
      }
    }
  }, [progress])

  const getDadosContaBenef = async (idUsrContr?: string) => {
    setShowLoading(true);
    if (idUsrContr || benef?.idUsrContr) {
      const result = await getDadosContaBeneficiarioProdutoExecutivo(Number(idUsrContr || benef?.idUsrContr));

      if (result !== null) {
        setDadosContaBeneficiario(result);
      }
    }
    setShowLoading(false);
  }

  useEffect(() => {
    const getSolicitacaoReembolso = async () => {
      setShowLoading(true)
      await getReembolsoPadrao().then((result) => {
        if (result !== null) {
          setReembolso(result);
          getUser();
        }
      });
    }

    const getUser = async () => {
      const isLiminar = await getLiminarReembolso();

      if (benef?.indPermiteReembolsoPadrao === 'S' && !isLiminar) {
        if (!agreed) {
          setOpen(true);
        }
      }
      else {
        setStep(ExecutiveRefundRequestTabsEnum.SelecaoBeneficiario);
      }
    }

    getDadosContaBenef();
    identifiesRefundType();
    getSolicitacaoReembolso();
  }, []);

  const handleDadosContaBeneficiario = async () => {
    getDadosContaBenef(beneficiary?.idUsrContrDependente);
  }

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  const identifiesRefundType = () => {
    if (benef?.indPermiteProdExecutivo === 'S') {
      setTipoReembolso('executivo');
    } else if (benef?.indPermiteReembolso === 'S') {
      setTipoReembolso('pleno');
    }
  }

  const handleTermsOfUse = async (showModal: boolean) => {
    setAgreed(showModal);
    setOpen(false);
  }

  const closeTermsOfUse = () => {
    setOpen(false);
    navigate(-1);
  }

  const handleProceedProtocolStep = (prot: string) => {
    setProtocolAtendimentoPrevio(prot);
    nextStep();
  }

  const handleProceedSelecaoBeneficiario = (celResult: string, emailResult: string, beneficiary: ListaDependentes) => {
    setCel(celResult);
    setEmail(emailResult);
    setBeneficiary(beneficiary);
    getDadosContaBenef(beneficiary.idUsrContrDependente)
    nextStep();
  }

  const handleRules = (stepSelecaoBeneficiario: boolean) => {
    setRulesSelecaoBeneficiario(stepSelecaoBeneficiario);
    setOpenRules(true);
  }

  const closeRules = () => {
    setOpenRules(false);
    setRulesSelecaoBeneficiario(false);
  }

  const closeRulesStepSelecaoBeneficiario = () => {
    setOpenRules(false);
    navigate(-2);
  }

  const handleProceedDadosCreditoEmConta = async (acc: LstDadosContasCadastradas) => {
    setAccount(acc);
    const idUsrContrAsString = beneficiary?.idUsrContrDependente || "";
    if (tipoReembolso !== 'executivo') {
      await gerarPedidoReembolso(acc.idCadContaReembolso, idUsrContrAsString, '', '', [], 0.01); //Este método gera um reembolso padrão com valor de 0.01 para que possamos ter o idPedido
    } else {
      nextStep();
    }
  }

  const gerarPedidoReembolso = async (
    idCadContaReembolso: string, idUsrContr: string, motivo: string,
    idPedidoReembolso: string, files?: Array<Anexo>, vlrTotal?: number, novoVlr?: number,
  ) => {
    setShowLoading(true);
    const response = await gravaPedidoReembolso(email, cel, idCadContaReembolso, idUsrContr, motivo, idPedidoReembolso, vlrTotal, novoVlr);
    if (response?.status === 200) {
      if (tipoReembolso === 'executivo') {
        setIdPedidoReembolso(response.data.idPedidoReembolso);
        gravarAnexos(files ?? anexos, Number(response.data.idPedidoReembolso));
      } else {
        setIdPedidoReembolso(response.data.idPedidoReembolso);
        nextStep();
      }
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro. Tente novamente em instantes.');
    }
    setShowLoading(false);
  }

  const handleProceedDadosProcedimentoExecutivo = async (files: Array<Anexo>, costValue: string) => {
    setAnexos(files);
    setCost(costValue);
    const idUsrContrAsString = beneficiary?.idUsrContrDependente || benef?.idUsrContr.toString() || "";
    await gerarPedidoReembolso(account.idCadContaReembolso, idUsrContrAsString, '', '', files, Number(costValue),);
  }

  const fetchResumoReembolso = async (idPedidoReembolso: number) => {
    setShowLoading(true);
    const response = await getdadosrevisaoprodutoexecutivo(idPedidoReembolso);
    if (response?.status === 200) {
      setResumoReembolso(response.data);
      nextStep();
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro. Tente novamente em instantes.');
    }
    setShowLoading(false);
  }

  const handleProceedDadosProcedimento = (procedimentosRealizados: ProcedimentoRealizado[], valorTotal: string) => {
    setLstProcedimentosRealizados(procedimentosRealizados);
    setValorTotal(valorTotal);
    nextStep();
  }

  const handleProceedAnexoMotivo = async (files: Array<Anexo>, motivoAtendimentoParticular: string) => {
    const success = await incluirProceds(motivoAtendimentoParticular, files);
    if (success) {
        setAnexos(files);
        setMotivoAtendimentoParticular(motivoAtendimentoParticular);
        nextStep();
    }
}

const incluirProceds = async (motivo: string, files: Array<Anexo>): Promise<boolean> => {
    setShowLoading(true);
    try {
        const lstProcedimentosRequest = lstProcedimentosRealizados.map(procedimento => ({
            codProced: procedimento.procedimento?.codProced || '',
            qtdProcedimento: parseInt(procedimento.quantidade, 10),
            dtProcedimento: procedimento.datas.map(data => ({ dtProcedimento: data.format('DD/MM/YYYY') })),
            totalGasto: parseFloat(procedimento.valorPago),
            especialidade: procedimento.especialidade?.id || ''
        }));

        const response = await inclurProcedimentos(motivo, idPedidoReembolso, lstProcedimentosRequest);
        if (response?.status !== 200) {
            console.error(response);
            openModalError('Erro', 'Ocorreu um erro. Tente novamente em instantes.');
            return false;
        }

        const anexosGravados = await gravarAnexos(files, Number(idPedidoReembolso));
        return anexosGravados;

    } finally {
        setShowLoading(false);
    }
}

const gravarAnexos = async (files: Array<Anexo>, idPedidoReembolso: number): Promise<boolean> => {
    const response = await gravaarquivospedidoreembolso(idPedidoReembolso, files);
    if (response?.status !== 200) {
        console.error(response);
        openModalError('Erro', 'Ocorreu um erro. Tente novamente em instantes.');
        return false;
    }

    if (tipoReembolso === 'executivo') {
        fetchResumoReembolso(idPedidoReembolso);
    }

    return true;
}

  const backStep = (index?: number) => {
    setStep((current) => {
      let back = current - 1;
      if (index !== undefined) {
        back = index + 1;
      }

      if (tipoReembolso === 'executivo') {
        if (Object.values(ExecutiveRefundRequestTabsEnum).includes(back)) {
          navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${back}`);
          return back;
        } else {
          navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${current}`);
          return current;
        }
      }
      if (Object.values(DefaultRefundRequestTabsEnum).includes(back)) {
        navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${back}`);
        return back;
      } else {
        navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${current}`);
        return current;
      }
    });
  };

  const nextStep = () => {
    setStep((current) => {
      const next = current + 1;
      if (tipoReembolso === 'executivo') {
        if (Object.values(ExecutiveRefundRequestTabsEnum).includes(next)) {
          navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${next}`);
          return next;
        } else {
          navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${current}`);
          return current;
        }
      }
      if (Object.values(DefaultRefundRequestTabsEnum).includes(next)) {
        navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${next}`);
        return next;
      } else {
        navigate(`/financeiro/reembolso/solicitacaoDeReembolso/${current}`);
        return current;
      }
    });
  };

  const handleProceedDadosPrestador = (dadosPrestador: DadosPrestador) => {
    setDadosPrestador(dadosPrestador);
    nextStep();
  }

  const handleEditInfos = async () => {
    setShowLoading(true);
    const response = await cancelaPedidoReembolso(Number(idPedidoReembolso));
    if (response?.status === 200) {
      setStep(1);
      setUserRequestedToEditInfos(true);
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro. Tente novamente em instantes.');
    }
    setShowLoading(false);
  }

  const gravarPedidoReembolsoOuvidor = async () => {
    setShowLoading(true);
    const response = await gravarPedidoOuvidorReembolso(idPedidoReembolso, Number(beneficiary?.idUsrContrDependente) || 0, protocolAtendimentoPrevio, dadosPrestador);
    if (response?.status === 200) {
      setProtocol(response.data);
      setFinalized(true);
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro. Tente novamente em instantes.');
    }
    setShowLoading(false);
  }

  const solicitarNovoReembolso = () => {
    //Reinicializa o valor de todos os campos do reembolso para evitar conflitos
    setFinalized(false);
    setUserRequestedToEditInfos(false);
    setProtocol('');
    setProtocolAtendimentoPrevio('');
    setAccount(defaultAccount);
    setLstProcedimentosRealizados([]);
    setAnexos([]);
    setMotivoAtendimentoParticular('');
    setIdPedidoReembolso('');
    //Retorna ao primeiro passo para reiniciar processo de reembolso
    if (tipoReembolso !== 'executivo') {
      setStep(0);
    } else {
      setStep(1);
    }
  }

  return (
    <div className="refund-request-holder">
      <LoadingApp showLoading={showLoading} />
      {step === ExecutiveRefundRequestTabsEnum.Protocol &&
        <ProtocolStep handleProtocolStep={handleProceedProtocolStep} />
      }
      {step !== ExecutiveRefundRequestTabsEnum.Protocol &&
        <>
          <PageTitle text="Reembolso" style={{marginBottom: '20px'}} />
          <div className="refund-request-information-help" style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <p style={accessibility.textStyleAccessibility}>Para informações de reembolso, <button className='refund-rules-button' onClick={() => handleRules(false)}><b><u style={accessibility.textStyleAccessibility}>consulte o informativo.</u></b></button></p>
          </div>
          {tipoReembolso === 'executivo' ?
            <DefaultTabs
              stepLabels={['Beneficiário', 'Conta para crédito', 'Valor e anexos', 'confirmação']}
              step={step - 1}
              onTabClick={(index) => backStep(index)}
            />
            :
            <DefaultTabs
              stepLabels={['Beneficiário', 'Conta para crédito', 'Dados do prestador', 'Dados do procedimento', 'Anexos e motivos', 'Confirmação']}
              step={step - 1}
              onTabClick={(index) => backStep(index)}
            />
          }
          <div className="refund-request-content">
            {tipoReembolso === 'executivo' ?
              <>{!finalized ?
                <>
                  {step === ExecutiveRefundRequestTabsEnum.SelecaoBeneficiario &&
                    <StepSelecaoBeneficiario cel={benef?.cel || ''} email={benef?.email || ''} handleFirstStep={handleProceedSelecaoBeneficiario}
                      handleRegrasReembolso={() => handleRules(true)}
                      beneficiarySelected={beneficiary}
                    />
                  }
                  {step === ExecutiveRefundRequestTabsEnum.DadosParaCreditoEmConta &&
                    <StepDadosParaCreditoEmConta dadosContaBeneficiario={dadosContaBeneficiario}
                      handleSecondStep={handleProceedDadosCreditoEmConta} handleBackSecondStep={backStep}
                      dadosContasCadastradas={account} userRequestedToEditInfos={userRequestedToEditInfos}
                      handleDadosContaBeneficiario={handleDadosContaBeneficiario} idPessoaDependente={beneficiary?.idPessoaDependente || ''}
                      idUsrContr={beneficiary?.idUsrContrDependente || ''}
                    />
                  }
                  {step === ExecutiveRefundRequestTabsEnum.DadosProcedimento &&
                    <StepDadosProcedimentoExecutivo
                      handleThirdStep={handleProceedDadosProcedimentoExecutivo} handleBackThirdStep={backStep}
                      userRequestedToEditInfos={userRequestedToEditInfos} anexosAdicionados={anexos}
                      valorTotalApontado={cost}
                    />
                  }
                  {step === ExecutiveRefundRequestTabsEnum.RevisaoFinalizacao &&
                    <StepRevisaoFinalizacaoExecutivo
                      resumoReembolsoExecutivo={resumoReembolso}
                      anexos={anexos}
                      handleBack={backStep}
                      handleEditInfos={handleEditInfos}
                      handleProceed={gravarPedidoReembolsoOuvidor}
                      benef={beneficiary?.nomeDependente || ''}
                      cel={cel}
                      email={email} />
                  }
                </>
                :
                <ProtocolShow protocolo={protocol} handleNewRefund={solicitarNovoReembolso} />
              }
              </>
              :
              <>
                {!finalized ?
                  <>
                    {step === DefaultRefundRequestTabsEnum.SelecaoBeneficiario &&
                      <StepSelecaoBeneficiario cel={benef?.cel || ''} email={benef?.email || ''} handleFirstStep={handleProceedSelecaoBeneficiario}
                        handleRegrasReembolso={() => handleRules(true)}
                        beneficiarySelected={beneficiary}
                      />
                    }
                    {step === DefaultRefundRequestTabsEnum.DadosParaCreditoEmConta &&
                      <StepDadosParaCreditoEmConta dadosContaBeneficiario={dadosContaBeneficiario}
                        handleSecondStep={handleProceedDadosCreditoEmConta} handleBackSecondStep={backStep}
                        userRequestedToEditInfos={userRequestedToEditInfos} dadosContasCadastradas={account}
                        handleDadosContaBeneficiario={handleDadosContaBeneficiario} idPessoaDependente={beneficiary?.idPessoaDependente || ''}
                        idUsrContr={beneficiary?.idUsrContrDependente || ''}
                      />
                    }
                    {step === DefaultRefundRequestTabsEnum.DadosPrestador &&
                      <StepDadosPrestador handleProceed={handleProceedDadosPrestador}
                        handleBack={backStep} setEspecialidades={setLstEspecialidades}
                        userRequestedToEditInfos={userRequestedToEditInfos} dadosPrestador={dadosPrestador}
                      />
                    }
                    {step === DefaultRefundRequestTabsEnum.DadosProcedimento &&
                      <StepDadosProcedimento handleProceed={handleProceedDadosProcedimento}
                        handleBack={backStep} idPedidoReembolso={idPedidoReembolso} especialidades={lstEspecialidades}
                        userRequestedToEditInfos={userRequestedToEditInfos} procedimentosRealizados={lstProcedimentosRealizados} valorTotalProp={valorTotal}
                      />
                    }
                    {step === DefaultRefundRequestTabsEnum.AnexosMotivo &&
                      <StepAnexoMotivo handleProceed={handleProceedAnexoMotivo} handleBack={backStep}
                        userRequestedToEditInfos={userRequestedToEditInfos} anexosAdicionados={anexos}
                        motivo={motivoAtendimentoParticular}
                      />
                    }
                    {step === DefaultRefundRequestTabsEnum.TermosFinalizacao &&
                      <StepTermoFinalizacao
                        handleProceed={gravarPedidoReembolsoOuvidor} handleBack={backStep} handleEditInfos={handleEditInfos}
                        benefData={benef!} accountData={account} procedData={lstProcedimentosRealizados}
                        attachments={anexos} totalValue={valorTotal} benef={beneficiary?.nomeDependente || ''} cel={cel} email={email}
                      />
                    }
                  </>
                  :
                  <ProtocolShow protocolo={protocol} handleNewRefund={solicitarNovoReembolso} />
                }
              </>
            }
          </div>
        </>
      }
      <TermoDeUsoModal handleTermsOfUse={handleTermsOfUse} closeTermsOfUse={closeTermsOfUse} open={open} passo1={reembolso.passo1} />
      <RegrasReembolsoModal open={openRules}
        closeTermsOfUse={rulesSelecaoBeneficiario ? closeRulesStepSelecaoBeneficiario : closeRules}
        isCalledBySelecaoBeneficiario={rulesSelecaoBeneficiario}
        acceptedTermsOfUse={closeRules}
      />
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </div>
  )
}

export default SolicitacaoDeReembolso;